import React from 'react';
import { convert24hourTo12HourFormat } from '../../_helpers/utility';

const TimeComponent: React.FC<{
  startTime: string;
  endTime: string;
}> = ({ startTime, endTime }) => {
  const [firstTime, secondTime] =
    startTime <= endTime ? [startTime, endTime] : [endTime, startTime];
  return (
    <div className="restaurant-time inter-12">
      <span>{startTime && convert24hourTo12HourFormat(firstTime)}</span>
      <span>&nbsp;-&nbsp;</span>
      <span>{endTime && convert24hourTo12HourFormat(secondTime)}</span>
    </div>
  );
};

export default TimeComponent;
